import { Media } from './media';
import { MotesPaths } from './motes-paths';

export class MapStyle {
    public key: string = "";
    public title: string = "";
    public text: string = "";
    public image: Media = new Media();
    public style: string = MotesPaths.MAPBOX_DEFAULT_STYLE;

    // Owner project allowed to change the MapStyle
    public project: string = "default";

    // Firebase time stamp object on or timestamp string
    public createdOn: any = "";

    constructor(key: string = null, json: any = {}) {
        this.key = key;
        if(json) this.updateFromJson(json);
    }

    public updateFromJson(json: any): void {
        this.title = json.title || "Custom Map Style";
        this.text = json.text || "No description yet";
        this.project = json.project || "default";
        this.createdOn = json.createdOn || null;
        this.image.fromJson(json.image);
        this.style = json.style || "";
    }

    public toJson() {
        return {
            title: this.title,
            text: this.text,
            createdOn: this.createdOn,
            project: this.project,
            image: this.image.toJson(),
            style: this.style
        };
    }

    public toString(): string {
        return "\MapStyle object \nKey: '" + this.key + "'\Title: " + this.title + " Created on:" + this.createdOn;
    }
}
